import React from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { Dropdown, Menu } from 'antd'
import { DownOutlined } from '@ant-design/icons'
import * as DROPDOWN from 'constant/dropdown'
import { showSubTable } from 'action/table'
import styles from 'view/component/table-columns/insight-actions/styles'
import PropTypes from 'prop-types'

const Action = ({ showSubTable, subCategory, category }) => {
  const handleClick = () => {
    showSubTable(subCategory, category)
  }

  return (<span>
    <Dropdown
      overlay={
        <Menu>
          <Menu.Item>
            <a onClick={handleClick}>Order Sub Categories</a>
          </Menu.Item>
        </Menu>
      }
      trigger={[DROPDOWN.TRIGGER]}
    >
      <div className={styles.show_more}>
        <span>More</span>
        <DownOutlined />
      </div>
    </Dropdown>
  </span>)
}

Action.propTypes = {
  category: PropTypes.object,
  showSubTable: PropTypes.func,
  subCategory: PropTypes.array
}

const mapDispatchToProps = (dispatch) => ({
  showSubTable: bindActionCreators(showSubTable, dispatch)
})

export default connect(null, mapDispatchToProps)(Action)
